import React, { useState, useEffect } from "react";
import { getplayList } from "../Api/spotifyapi";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { PiSpotifyLogoLight } from "react-icons/pi";

import { useDispatch, useSelector } from "react-redux";
const SpotifyAuth = () => {
  const CLIENT_ID = "ac475d6bec40429a96dc70a3110af05e";
  const REDIRECT_URL = "http://localhost:3000/spotify-auth";
  const AUTH_ENDPOINT = "https://accounts.spotify.com/authorize";
  const RESPONSE_TYPE = "token";
  const accessUrl = `${AUTH_ENDPOINT}?client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URL}&response_type=${RESPONSE_TYPE}`;
  const dispatch=useDispatch();
  const token = useSelector((state) => state.SpotifyData).token;
  const navigate = useNavigate();
useEffect(() => {
    const hash = window.location.hash.substring(1);
    let token = localStorage.getItem("token");
    if (!token && hash) {
      token = new URLSearchParams(hash).get("access_token");
      window.location.hash = "";
      localStorage.setItem("token", token);
      
      dispatch({
        type: "SET_TOKEN",
        token: token
      });
    }
  
   
  },[]);

useEffect(()=>{
  const token =localStorage.getItem('token');
  console.log(token)
  if(token){
    navigate(-2)
   
  }
},[token])
 
  return (
    <div className="flex flex-col justify-center gap-3 h-[90vh] ">
       
            <PiSpotifyLogoLight
              color="green"
              className="w-[50vw] h-[50vw] self-center"
            />
      
          <button type="button" className="text-white mx-4 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"> <a href={accessUrl}>Login With Spotify</a> </button>
    </div>
  );
};

export default SpotifyAuth;

